import {useState} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Card, Typography } from "@mui/material";
import Map from './Map';
import ResultsPane from './ResultsPane';
//import ProjectPane from './ProjectPane';
import FilterPane from './FilterPane';
import StatBanner from './StatBanner';
import ProjectPopover from './ProjectPopover';

const theme = createTheme({
  typography: {
    fontFamily: ["Radio Canada Big", "Arial"].join(",")
  }
});

function Main(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [ refreshList, setRefreshList ] = useState(false);
    const [ activeResult, setActiveResult] = useState(null);
    const [ projects, setProjects ] = useState([]);
    const [ filteredProjects, setFilteredProjects ] = useState([]);
    const [ organisations, setOrganisations ] = useState([]);
    const [ techProviders, setTechProviders ] = useState([]);

    const selectedResult = (result) => {
      setActiveResult(result);
  }

  return (
<ThemeProvider theme={theme}>
    <Box sx={{ flexGrow: 1 }}>
        <Map {...{ isOpen, setIsOpen, activeResult, setActiveResult, projects }} onSelectResult={selectedResult}/>

        <Box sx={{ backgroundColor: '#ffffff', padding: '20px', width: '70%', marginLeft: 'auto', marginRight: 'auto'}}>
          <StatBanner {...props} {...{projects, setProjects}} />
        </Box>
        <Box sx={{height:'35px', display: 'flex', alignItems: 'flex-end', float: 'right'}}>
          <Tooltip title="Site Powered By">
            <img width="35px" src="dev.png" alt="Site Powered By" />
          </Tooltip>
        </Box>

        <Box sx={{ backgroundColor: '#ffffff', marginBottom: '2em', width: '95%', marginLeft: 'auto', marginRight: 'auto'}}>
          <FilterPane projects={projects} setFilteredProjects={setFilteredProjects} techProviders={techProviders} organisations={organisations}/>
        </Box>

        <Card sx={{backgroundColor: '#f1f1f1', width: '95%', marginLeft: 'auto', marginRight: 'auto'}}>
          <ResultsPane {...props} {...{refreshList, setRefreshList, projects, setProjects, organisations, setOrganisations, 
            techProviders, setTechProviders, filteredProjects, setFilteredProjects}} onSelectResult={selectedResult} />
        </Card>
    </Box>
    <ProjectPopover {...{ activeResult, setActiveResult, organisations, techProviders }} />
</ThemeProvider>
  );
}

export default Main;
